module.exports = __webpack_public_path__ + "img/text-logo-standard.70657336.png";